import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { ChatInput as UIChatInput } from '@edusense/shared-ui-chat';
import { useMcp } from '../../hooks/useMcp';
import McpToolsDropdown from './McpToolsDropdown';
export default function ChatInput(props) {
    const [selectedTools, setSelectedTools] = useState([]);
    const { tools, isConnected, activeServer } = useMcp();
    const handleToolSelect = (tool)=>{
        setSelectedTools((prev)=>{
            const exists = prev.find((t)=>t.name === tool.name);
            if (exists) {
                return prev.filter((t)=>t.name !== tool.name);
            } else {
                return [
                    ...prev,
                    tool
                ];
            }
        });
    };
    const handleToolRemove = (toolName)=>{
        setSelectedTools((prev)=>prev.filter((t)=>t.name !== toolName));
    };
    const handleSendMessage = (message, files, tools)=>{
        props.onSendMessage(message, files, tools);
        setSelectedTools([]);
    };
    return /*#__PURE__*/ _jsx(UIChatInput, {
        ...props,
        onSendMessage: handleSendMessage,
        tools: tools,
        selectedTools: selectedTools,
        onToolSelect: handleToolSelect,
        onToolRemove: handleToolRemove,
        showToolsButton: isConnected && tools.length > 0,
        toolsDropdownComponent: (dropdownProps)=>/*#__PURE__*/ _jsx(McpToolsDropdown, {
                ...dropdownProps,
                serverName: activeServer?.config.name || 'Unknown'
            }),
        showSettingsButton: true
    });
}
